// @flow
import * as React from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import classNames from 'classnames/bind';

import mapItems from '../mapItems';
// import mapChildren from '../mapChildren';
import styles from './InsideMenu.module.scss';;

const cx = classNames.bind(styles);

export type MenuItemType = {
  id: string | number,
  title: string,
  path?: string,
  activeClassName?: string,
  onClick?: (e: SyntheticEvent<HTMLElement>) => void,
  active?: boolean,
  component?: React.Element<any>
}

type Props = {
  items?: Array<MenuItemType>,
  className?: string,
  containerClassName?: string,
  scrollable?: boolean,
  children?: any,
};

const InsideMenu = ({ items, className, containerClassName, scrollable, children }: Props) => (scrollable
  ? <Scrollbars className={className}>
    <div className={cx(styles.container, containerClassName)}>
      {items && mapItems(items)}
      {children}
    </div>
  </Scrollbars>
  : <div className={cx(className, containerClassName)}>
      {items && mapItems(items)}
      {children}
  </div>
);

export default InsideMenu;
